/*
Monotype Foundry Platform API
Version 1.0.0

Definition: CreateAiFeedbackRequest

Properties:
  assetType: string (required)
  assetId: string (required)
  action: string (required)
  suggestionType: string (required)
  foundryId: string
  metadata: object
*/

var CreateAiFeedbackRequest = (function () {
  function validateCreateAiFeedbackRequest (arg) {
    // Validate assetType
    if (!arg.assetType) {
      throw new Error('CreateAiFeedbackRequest.assetType: Missing property')
    }
    if (arg.assetType && !(typeof arg.assetType === 'string')) {
      throw new Error('CreateAiFeedbackRequest.assetType: Wrong type: Got \'' + (typeof arg.assetType) + '\', but expected: \'string\'')
    }
    // Validate assetId
    if (!arg.assetId) {
      throw new Error('CreateAiFeedbackRequest.assetId: Missing property')
    }
    if (arg.assetId && !(typeof arg.assetId === 'string')) {
      throw new Error('CreateAiFeedbackRequest.assetId: Wrong type: Got \'' + (typeof arg.assetId) + '\', but expected: \'string\'')
    }
    // Validate action
    if (!arg.action) {
      throw new Error('CreateAiFeedbackRequest.action: Missing property')
    }
    if (arg.action && !(typeof arg.action === 'string')) {
      throw new Error('CreateAiFeedbackRequest.action: Wrong type: Got \'' + (typeof arg.action) + '\', but expected: \'string\'')
    }
    // Validate suggestionType
    if (!arg.suggestionType) {
      throw new Error('CreateAiFeedbackRequest.suggestionType: Missing property')
    }
    if (arg.suggestionType && !(typeof arg.suggestionType === 'string')) {
      throw new Error('CreateAiFeedbackRequest.suggestionType: Wrong type: Got \'' + (typeof arg.suggestionType) + '\', but expected: \'string\'')
    }
    // Validate foundryId
    if (arg.foundryId && !(typeof arg.foundryId === 'string')) {
      throw new Error('CreateAiFeedbackRequest.foundryId: Wrong type: Got \'' + (typeof arg.foundryId) + '\', but expected: \'string\'')
    }
    // Validate metadata
    if (arg.metadata && !(typeof arg.metadata === 'object')) {
      throw new Error('CreateAiFeedbackRequest.metadata: Wrong type: Got \'' + (typeof arg.metadata) + '\', but expected: \'object\'')
    }
  }
  function buildCreateAiFeedbackRequest (arg) {
    var CreateAiFeedbackRequest = arg
    // Complete assetType
    // Expected Type: string
    CreateAiFeedbackRequest.assetType = CreateAiFeedbackRequest.assetType || ''
    // Complete assetId
    // Expected Type: string
    CreateAiFeedbackRequest.assetId = CreateAiFeedbackRequest.assetId || ''
    // Complete action
    // Expected Type: string
    CreateAiFeedbackRequest.action = CreateAiFeedbackRequest.action || ''
    // Complete suggestionType
    // Expected Type: string
    CreateAiFeedbackRequest.suggestionType = CreateAiFeedbackRequest.suggestionType || ''
    // Complete foundryId
    // Expected Type: string
    CreateAiFeedbackRequest.foundryId = CreateAiFeedbackRequest.foundryId || ''
    // Complete metadata
    // Expected Type: object
    CreateAiFeedbackRequest.metadata = CreateAiFeedbackRequest.metadata || {}
    // Complete metadata.message
    // Expected Type: string
    CreateAiFeedbackRequest.metadata.message = CreateAiFeedbackRequest.metadata.message || ''
    return CreateAiFeedbackRequest
  }
  return {
    validate: validateCreateAiFeedbackRequest,
    build: buildCreateAiFeedbackRequest
  }
})()

module.exports = CreateAiFeedbackRequest
